import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LoginModel } from '../../models/login.model';
import { RecoverModel } from '../../models/recover-pass.model';
import * as CryptoJS from 'crypto-js';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private apiUrl = environment.apiUrl;
  private routerApi = 'api/users';
  private notificationApi = 'api/notifications';
  private secretKey = 'za63qj2p';
  private routerCouponApi = 'api/coupons';
  public places_colombia: any[] = [];
  public departaments_colombia: any[] = [];
  public cities_colombia: any[] = [];
  private loginSuccessSource = new BehaviorSubject<boolean>(false);
  loginSuccess$ = this.loginSuccessSource.asObservable();
  private server_imagine_places =
    this.apiUrl+'/api/countrylibrary/es/america/COL/';
  private headers = new HttpHeaders({
    'Content-Type': 'application/json',
    apiKey: 'VQYHJtawdLuyqg4bDEm5kEwHnZfZ5lKW',
  });
  public tempUserRegistrationData: any = {};
  public notifyDirectionAddedSource = new BehaviorSubject<boolean>(false);
  public notifyDirectionAdded$ = this.notifyDirectionAddedSource.asObservable();

  constructor(private http: HttpClient, private router: Router) { }

  getNotifications(): Observable<any> {
    const token = this.getUserData()?.token;
    const userId = this.getUserData()?.data_user.id;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    return this.http.get(`${this.apiUrl}/${this.notificationApi}/${userId}`, { headers });
  }

  markNotificationAsRead(id: string = ''): Observable<any> {
    const token = this.getUserData()?.token;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    return this.http.post(`${this.apiUrl}/${this.notificationApi}/notification/checkRead/${id}`, { headers });
  }

  toggleLike(id: string, action: string): Observable<any> {
    const token = this.getUserData()?.token;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    const body = {
      calification: id,
      action: action
    };

    return this.http.post(`${this.apiUrl}/${this.routerApi}/likeUsersReview/user`, body);
  }

  notifyLoginSuccess(): void {
    this.loginSuccessSource.next(true);
  }
  login(value: string, password: string): Observable<LoginModel> {
    const platform = 'web';
    const body = {
        ...(this.isNumber(value) ? { phone: value } : { email: value }),
        password,
        platform
    };
    
    return this.http.post<LoginModel>(
        `${this.apiUrl}/${this.routerApi}/loginApp`,
        body
    );
  }
  isNumber(value: string){
    return /^-?\d*\.?\d+$/.test(value);
  }
  recover(value: string, origin: any): Observable<RecoverModel> {
    return this.http.post<RecoverModel>(
      `${this.apiUrl}/${this.routerApi}/recover-password-by-otp`, { 
        ...(this.isNumber(value) ? { phone: value } : { email: value }),
        origin,
        method: 'recover-password' 
      }
    );
  }
  isAuthenticated(): boolean {
    return !!localStorage.getItem('userData');
  }
  setData(userData: any): void {
    const encryptedData = this.encryptData(userData);
    if (userData && userData.token) {
      localStorage.setItem('token', userData.token);
    }
    localStorage.setItem('userData', encryptedData);
    this.notifyLoginSuccess();
  }

  logout(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('userData');
    this.notifyLoginSuccess(); // Notify components about logout
    // Swal.fire({
    //   icon: 'success',
    //   title: 'Cerrar sesión',
    //   text: 'Sesión cerrada correctamente.',
    //   confirmButtonText: 'Aceptar',
    //   buttonsStyling: false,
    // }).then(() => {
    //   this.router.navigate(['/home']);
    // });
  }

  deletC(): Observable<any> {
    const token = this.getUserData()?.token;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    return this.http.delete<any>(`${this.apiUrl}/${this.routerApi}`,
      { headers }
    );
  }

  getUserData(): any {
    const encryptedData = localStorage.getItem('userData');
    if (encryptedData) {
      const decryptedData = this.decryptData(encryptedData);
      return decryptedData;
    }
    return null;
  }
  likeProduct(productId: string): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}/${this.routerApi}/productLike/user`,
      { productId }
    );
  }
  private encryptData(data: any): string {
    return CryptoJS.AES.encrypt(
      JSON.stringify(data),
      this.secretKey
    ).toString();
  }
  public register(
    value: string,
    password: string,
    name: string,
    lastname: string,
    origin: string
  ): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}/${this.routerApi}/register`,
      { ...(this.isNumber(value) ? { phone: value } : { email: value }), password, name, lastname, origin }
    );
  }
  public verifyAccount(
    value: string,
    otp: string,
    method: string | null = null,
    origin: string | null = null
  ): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}/${this.routerApi}/verify-otp`,
      { 
        ...(this.isNumber(value) ? { phone: value } : { email: value }), 
        otp,
        ...(method ? { method } : {}),
        ...(origin ? { origin } : {})
      }
    );
  }
  private decryptData(data: string): any {
    const bytes = CryptoJS.AES.decrypt(data, this.secretKey);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }
  getDataUser(id: string): Observable<any> {
    const token = this.getUserData()?.token;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    let params = new HttpParams();
    params = params.set('id', id);
    
    return this.http.get<any>(`${this.apiUrl}/${this.routerApi}/${id}`, { headers });
  }
  getCoupon(coupon: string): Observable<any> {
    return this.http.get<any>(
      `${this.apiUrl}/${this.routerCouponApi}/coupons/name/${coupon}`
    );
  }
  updateUser(id: string, userData: any): Observable<any> {
    const token = this.getUserData()?.token;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    return this.http.put<any>(`${this.apiUrl}/${this.routerApi}/${id}`, 
      userData,
      { headers }
    );
  }
  public async getDepartmentFromServerImagine() {
    try {
      const resp: any = await this.http
        .get(this.server_imagine_places, {
          headers: this.headers,
        })
        .toPromise();
      this.departaments_colombia = resp.data;
      return resp.data;
    } catch (err) {
      console.log(err);
    }
  }
  public async getCitiesFromServerImagine(department: any) {
    try {
      const resp: any = await this.http
        .get(`${this.server_imagine_places}${department}/`, {
          headers: this.headers,
        })
        .toPromise();
      this.cities_colombia = resp.data;
      return resp.data;
    } catch (err) {
      console.log(err);
    }
  }
  getFacturationData(userId: string): Observable<any> {
    return this.http.get<any>(
      `${this.apiUrl}/${this.routerApi}/${userId}/facturation`
    );
  }
  updateFacturationData(userId: string, facturationData: any): Observable<any> {
    return this.http.put<any>(
      `${this.apiUrl}/${this.routerApi}/${userId}/facturation`,
      facturationData
    );
  }
  changePassword(newPassword: string, token: string = ''): any {
    const type = 'web';
    const headers = new HttpHeaders({
      Authorization: token,
    });
    return this.http.post<LoginModel>(
      `${this.apiUrl}/${this.routerApi}/changePassword`,
      { newPassword, type },
      { headers }
    );
  }
  changePasswordUser(lastpassword: string, newpassword: string): any {
    const token = this.getUserData()?.token;
    const tokenWithoutBearer = token.replace('Bearer ', '');
    const headers = new HttpHeaders({
      Authorization: tokenWithoutBearer,
    });
    return this.http.put<any>(
      `${this.apiUrl}/${this.routerApi}/updatePassword`,
      { current: lastpassword, newPass: newpassword },
      { headers }
    );
  }
  recoverPasswordUser(newPassword: string, otp: String, token: string = ''): any{
    const headers = new HttpHeaders({
      Authorization: token,
    });
    return this.http.post<LoginModel>(
      `${this.apiUrl}/${this.routerApi}/validate-reset-password`,
      { newPassword, otp },
      { headers }
    );
  }
  validateTokenExpiration(token: string = ''): any {
    const headers = new HttpHeaders({
      Authorization: token,
    });
    return this.http.post<LoginModel>(
      `${this.apiUrl}/${this.routerApi}/validateTokenExpiration`,
      { token }
    );
  }

  DeletDataUser(): Observable<any> {
    const token = this.getUserData()?.token;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    return this.http.delete<any>(`${this.apiUrl}/${this.routerApi}/delete-account`);
  }

  getUserByIdAndToken(userId: string, token: string): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    return this.http.get<any>(`${this.apiUrl}/${this.routerApi}/${userId}`);
  }

  registerAddress(userId: string, address: any){
    const body = {
        userId,
        ...address,
    };
    
    return this.http.post<any>(
        `${this.apiUrl}/${this.routerApi}/addAddress`,
        body
    );
  }

  updateAddress(userId: string, addressId: string, address: any){
    const body = {
        userId,
        ...address,
    };
    
    return this.http.put<any>(
        `${this.apiUrl}/${this.routerApi}/updateUserAddress/${addressId}`,
        body
    );
  }

  deleteAddress(userId: string, addressId: string){
    return this.http.delete<any>(
      `${this.apiUrl}/${this.routerApi}/deleteUserAddress/${userId}/${addressId}`
    );
  }

  public setNotifyDirectionAdded(value: boolean): void {
    this.notifyDirectionAddedSource.next(value);
  }
}
